import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export interface DialogAlertProps {
  withIcon?: boolean;
  message?: string;
  title?: string;
  onClose?: () => void;
}

export const DialogAlert: React.FC<DialogAlertProps> = ({
  withIcon = true,
  message,
  title,
  onClose,
}) => {
  return (
    <Dialog onClose={onClose} aria-labelledby="dialog-alert" open={true} className={'dialog-alert'}>
      <DialogTitle>
        {withIcon && <ErrorOutlineIcon className="dialog-alert__icon" />}
        {!!title && title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
